import type { ReactNode } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Typography } from "@circle-react-uikit/Typography";

type Sentiment = "default" | "warning" | "danger";

interface PaymentProcessorStatusAlertProps {
  badge?: ReactNode;
  description?: ReactNode;
  sentiment: Sentiment;
  title?: string;
}

export const PaymentProcessorStatusAlert = ({
  sentiment,
  title,
  badge,
  description,
}: PaymentProcessorStatusAlertProps) => {
  const freeTrialInputClassName = classNames(
    "md:border md:border-primary md:rounded-lg md:p-8 bg-primary",
    {
      "flex flex-row": sentiment !== "default",
    },
  );

  return (
    <div
      className={freeTrialInputClassName}
      data-testid="payment-processor-status"
    >
      <div className="flex flex-col gap-y-2">
        {badge && <div>{badge}</div>}
        {title && (
          <Typography.TitleMd data-testid="title">{title}</Typography.TitleMd>
        )}
        {description && <div data-testid="description">{description}</div>}
      </div>
    </div>
  );
};
